import { axios } from '../plugins/axios'
import { log, refactorExamQuestions } from '../plugins/helpers'
import ENV from './../env'
import { dataURItoBlob } from './../plugins/webcam'

import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    exam_details: null,
    questions: null,
    progress: null,
    previous_attempts: null
  },

  mutations: {
    SET_EXAM_DETAILS(state, payload) {
      state.exam_details = payload
      log('exam details', payload)
    },

    SET_QUESTIONS(state, payload) {
      log('questions before', payload)
      state.questions = refactorExamQuestions(payload)
      log('questions after', state.questions)
    },

    SET_PROGRESS(state, payload) {
      state.progress = payload
      log('progress', payload)
    },

    SET_PREVIOUS_ATTEMPTS(state, payload) {
      // get only last 30 attempts
      if (payload.length > 0) {
        state.previous_attempts = payload.slice(0, 30)
        log('previous attempts', state.previous_attempts)
      }
    },

    UPDATE_QUESTION_FLAG(state, payload) {
      log('Updating Q Flag')
      let { is_flagged, question_index } = payload
      Vue.set(state.questions[question_index], 'is_flagged', is_flagged)
    },

    UPDATE_CHECKBOX_CHOICE(state, payload) {
      let { question_index, choice_index, checked } = payload
      Vue.set(state.questions[question_index].choices[choice_index], 'is_chosen', checked ? 1 : 0)
    },

    UPDATE_RADIO_CHOICE(state, payload) {
      let { question_index, choice_index } = payload
      let choices = state.questions[question_index].choices

      log('payload', payload)
      log('quesrion', state.questions[question_index])
      log('chpoices', state.questions[question_index].choices)

      choices.forEach((choice, index) => {
        if (index === choice_index) {
          Vue.set(state.questions[question_index].choices[index], 'is_chosen', 1)
        } else {
          Vue.set(state.questions[question_index].choices[index], 'is_chosen', 0)
        }
      })
    }
  },

  actions: {
    setExamDetails({ commit }, payload) {
      commit('SET_EXAM_DETAILS', payload)
    },
    setQuestions({ commit }, payload) {
      commit('SET_QUESTIONS', payload)
    },

    setProgress({ commit }, payload) {
      commit('SET_PROGRESS', payload)
    },

    setPreviousAttempts({ commit }, payload) {
      commit('SET_PREVIOUS_ATTEMPTS', payload)
    },

    // invigilate check
    async preStartCheckLevelOne({ commit, dispatch, rootGetters, rootState }) {
      console.log('Level1')
      if (rootGetters['examIsInvigilated'] && !rootGetters['invigilate/initialInvigilateFulfilled']) {
        commit('SET_PAGE', 'invigilate_setup', { root: true })
      } else {
        console.log('Level1 OKK')
        if (!rootState.is_demo) {
          dispatch('preStartCheckLevelTwo')
        } else {
          console.log('Skipping Survey in Demo mode')
          dispatch('preStartCheckLevelThree')
        }
      }
    },

    // Initial Survey check
    async preStartCheckLevelTwo({ commit, dispatch, rootState }) {
      console.log('Level2')

      commit('LOADING', null, { root: true })

      let { data } = await axios.post(rootState.api.GET_INITIAL_SURVEY, {
        user_id: rootState.user_id,
        exam_id: rootState.exam_id,
        lang: rootState.language.selected_language.lang
      })

      dispatch('survey/setInitialSurvey', data.initial_survey, { root: true })
      dispatch('survey/setSurveyType', 'initial_survey', { root: true })

      commit('NOT_LOADING', null, { root: true })

      if (rootState.survey.initial_survey && rootState.survey.initial_survey.length) {
        commit('SET_PAGE', 'survey', { root: true })
      } else {
        console.log('Level2 OKK')
        dispatch('preStartCheckLevelThree')
      }
    },

    // PreStart Video check
    async preStartCheckLevelThree({ commit, dispatch, rootGetters }) {
      console.log('Level3')
      if (rootGetters['examIsInvigilated'] && !rootGetters['invigilate/preStartVideoFulfilled']) {
        commit('SET_PAGE', 'pre_start_video', { root: true })
      } else {
        console.log('Level3 OKK')
        dispatch('startExam')
      }
    },

    async startExam({ state, commit, rootState, rootGetters }) {
      commit('LOADING', null, { root: true })

      console.log('Startinggggggg')

      let { data } = await axios.post(rootState.api.START_EXAM, {
        user_id: rootState.user_id,
        exam_id: rootState.exam_id,
        lang: rootState.language.selected_language.lang
      })

      // exam details is needed during exam ...
      commit('SET_EXAM_DETAILS', data.exam_details)
      commit('SET_QUESTIONS', data.questions)
      commit('SET_FLAGS', data.flags, { root: true })

      commit('NOT_LOADING', null, { root: true })

      try {
        if (rootGetters['examIsInvigilated'] && rootGetters['invigilate/userPictureFulfilled']) {
          // send user picture
          let blob = dataURItoBlob(rootState.invigilate.user_picture)
          console.log(blob)
          let fd = new FormData()
          fd.append('picture', blob, 'picture.jpg')
          fd.append('user_id', rootState.user_id)
          fd.append('exam_start_datetime', parseInt(state.exam_details.start_datetime / 1000))
          console.log('PICTUREEEEEEEEEEEEE')
          console.log(parseInt(state.exam_details.start_datetime / 1000))
          fd.append('exam_id', rootState.exam_id)
          axios.post(ENV.invigilate.api_url + 'store-user-picture', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
        }

        // send user info
        if (rootGetters['examIsInvigilated']) {
          axios.post(ENV.invigilate.api_url + 'store-user-info', {
            exam_start_datetime: parseInt(state.exam_details.start_datetime / 1000),
            user_id: rootState.user_id,
            exam_id: rootState.exam_id,
            user_email: rootState.user_email
          })
        }

        if (rootGetters['examIsInvigilated'] && rootGetters['preStartVideoFulfilled']) {
          let fd = new FormData()
          fd.append('video', rootState.invigilate.pre_start_video, 'video.webm')
          fd.append('user_id', rootState.user_id)
          fd.append('exam_id', rootState.exam_id)
          fd.append('exam_start_datetime', parseInt(state.exam_details.start_datetime / 1000))
          axios.post(ENV.invigilate.api_url + 'store-pre-start-video', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
        }
      } catch (error) {
        console.error('error trying to send user picture')
        console.log(error)
      }

      // if exam is demo, user_id is created in backend and
      // send to front for further actions that need user_id
      // so we save it in storage
      if (rootState.is_demo) {
        commit('SET_USER_ID', data.user_id, { root: true })
      }

      commit('SET_PAGE', 'exam', { root: true })
    },

    // when user flags a question
    async updateQuestionFlag({ commit, rootState }, { question_id, checked, question_index }) {
      let input_data = {
        user_id: rootState.user_id,
        exam_id: rootState.exam_id,
        is_flagged: checked === true ? 1 : 0,
        question_id: question_id
      }

      log('sending flag data', input_data)

      let { data } = await axios.post(rootState.api.UPDATE_QUESTION_FLAG, input_data)

      if (data.status !== 'success') {
        log('Error update flag')
      } else {
        commit('UPDATE_QUESTION_FLAG', {
          is_flagged: checked === true ? 1 : 0,
          question_index
        })
      }
    },

    // async startExam({ state, commit, dispatch, rootState, rootGetters }) {
    //   if (rootGetters['examIsInvigilated'] && !rootGetters['invigilate/initialInvigilateFulfilled']) {
    //     commit('SET_PAGE', 'invigilate_setup', { root: true })
    //     return
    //   }

    //   if (rootGetters['examIsInvigilated'] && !rootGetters['invigilate/preStartVideoFulfilled']) {
    //     commit('SET_PAGE', 'pre_start_video', { root: true })
    //     return
    //   }

    //   let { data } = await axios.post(rootState.api.START_EXAM, {
    //     user_id: rootState.user_id,
    //     exam_id: rootState.exam_id,
    //     lang: rootState.language.selected_language.lang
    //   })

    //   // exam details is needed during exam ...
    //   commit('SET_EXAM_DETAILS', data.exam_details)
    //   commit('SET_QUESTIONS', data.questions)
    //   commit('SET_FLAGS', data.flags, { root: true })

    //   try {
    //     if (rootGetters['examIsInvigilated'] && rootGetters['invigilate/userPictureFulfilled']) {
    //       // send user picture
    //       let blob = dataURItoBlob(rootState.invigilate.user_picture)
    //       console.log(blob)
    //       let fd = new FormData()
    //       fd.append('picture', blob, 'picture.jpg')
    //       fd.append('user_id', rootState.user_id)
    //       fd.append('exam_start_datetime', parseInt(state.exam_details.start_datetime / 1000))
    //       console.log('PICTUREEEEEEEEEEEEE')
    //       console.log(parseInt(state.exam_details.start_datetime / 1000))
    //       fd.append('exam_id', rootState.exam_id)
    //       axios.post(ENV.invigilate.api_url + 'store-user-picture', fd, {
    //         headers: { 'Content-Type': 'multipart/form-data' }
    //       })
    //     }

    //     // send user info
    //     if (rootGetters['examIsInvigilated']) {
    //       axios.post(ENV.invigilate.api_url + 'store-user-info', {
    //         exam_start_datetime: parseInt(state.exam_details.start_datetime / 1000),
    //         user_id: rootState.user_id,
    //         exam_id: rootState.exam_id,
    //         user_email: rootState.user_email
    //       })
    //     }

    //     if (rootGetters['examIsInvigilated'] && rootGetters['preStartVideoFulfilled']) {
    //       let fd = new FormData()
    //       fd.append('video', rootState.invigilate.pre_start_video, 'video.webm')
    //       fd.append('user_id', rootState.user_id)
    //       fd.append('exam_id', rootState.exam_id)
    //       fd.append('exam_start_datetime', parseInt(state.exam_details.start_datetime / 1000))
    //       axios.post(ENV.invigilate.api_url + 'store-pre-start-video', fd, {
    //         headers: { 'Content-Type': 'multipart/form-data' }
    //       })
    //     }
    //   } catch (error) {
    //     console.error('error trying to send user picture')
    //     console.log(error)
    //   }

    //   // if exam is demo, user_id is created in backend and
    //   // send to front for further actions that need user_id
    //   // so we save it in storage
    //   if (rootState.is_demo) {
    //     commit('SET_USER_ID', data.user_id, { root: true })
    //   }

    //   dispatch('survey/setInitialSurvey', data.initial_survey, { root: true })
    //   dispatch('survey/setSurveyType', 'initial_survey', { root: true })

    //   if (rootState.survey.initial_survey && rootState.survey.initial_survey.length) {
    //     commit('SET_PAGE', 'survey', { root: true })
    //   } else {
    //     commit('SET_PAGE', 'exam', { root: true })
    //   }
    // },

    // when user click on choice (checkbox)
    async updateCheckboxChoice(
      { commit, dispatch, rootState },
      { choice_id, question_index, choice_index, checked }
    ) {
      try {
        commit('UPDATE_CHECKBOX_CHOICE', {
          checked,
          question_index,
          choice_index
        })

        let input_data = {
          user_id: rootState.user_id,
          exam_id: rootState.exam_id,
          choices: [
            {
              choice_id: choice_id,
              is_chosen: checked ? 1 : 0
            }
          ]
        }

        let { data } = await axios.post(rootState.api.UPDATE_CHOICE, input_data)
        if (data.status === 'success') {
          dispatch('hideConnectionError', null, { root: true })
        } else if (data.status === 'time_is_over') {
          dispatch('finishExam')
        }
      } catch (error) {
        dispatch('catchAllErrors', error, { root: true })
      }
    },

    // when user click on choice (radiobutton)
    async updateRadioChoice({ commit, rootState, state, dispatch }, { question_index, choice_index }) {
      try {
        commit('UPDATE_RADIO_CHOICE', { question_index, choice_index })

        let input_data = {
          user_id: rootState.user_id,
          exam_id: rootState.exam_id,
          choices: state.questions[question_index].choices
        }

        log('data', input_data)

        let { data } = await axios.post(rootState.api.UPDATE_CHOICE, input_data)

        if (data.status === 'success') {
          dispatch('hideConnectionError', null, { root: true })
        } else if (data.status === 'time_is_over') {
          dispatch('finishExam')
        }
      } catch (error) {
        dispatch('catchAllErrors', error, { root: true })
      }
    },

    async finishExam({ dispatch, commit, rootState }) {
      commit('LOADING', null, { root: true })

      log('send finishing exam data', {
        user_id: rootState.user_id,
        first_name: rootState.first_name,
        last_name: rootState.last_name,
        user_email: rootState.user_email,
        exam_id: rootState.exam_id
      })

      let { data } = await axios.post(rootState.api.FINISH_OR_TIME_OVER, {
        user_id: rootState.user_id,
        first_name: rootState.first_name,
        last_name: rootState.last_name,
        user_email: rootState.user_email,
        exam_id: rootState.exam_id
      })

      dispatch('invigilate/clearWebcamInterval', null, { root: true })
      dispatch('invigilate/clearScreenInterval', null, { root: true })
      dispatch('invigilate/stopAudioRecording', null, { root: true })
      // TODO: delete prestart video

      log('response  finish exam ', data)

      if (rootState.is_demo) {
        commit('SET_FLAGS', data.flags, { root: true })
        dispatch('results/setResults', data.exam_results, { root: true })
        commit('SET_PAGE', 'results', { root: true })
      } else {
        commit('SET_FLAGS', data.flags, { root: true })
        dispatch('results/setResults', data.exam_results, { root: true })
        dispatch('survey/setFinalSurvey', data.exam_results.total.final_survey, {
          root: true
        })
        dispatch('survey/setSurveyType', 'final_survey', { root: true })
        dispatch('updateCoverageTables', null, { root: true })

        if (rootState.survey.final_survey && rootState.survey.final_survey.length) {
          commit('SET_PAGE', 'survey', { root: true })
        } else {
          commit('SET_PAGE', 'results', { root: true })
        }
      }
      commit('NOT_LOADING', null, { root: true })
    }
  }
}
